import React from 'react'
import { isEmpty } from 'lodash'
import {
  DataTable,
  Table as CarbonTable,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  InlineLoading
} from 'carbon-components-react'
import './index.scss'

export default function Table(props) {
  const { config, data } = props
  const { columnsDef } = config

  return (
    <div className='kpi-table-wrapper'>
      {!isEmpty(data) ? (
        <DataTable className='table' zebra rows={data} headers={columnsDef}>
          {({ rows, headers }) => (
            <CarbonTable>
              <TableHead>
                <TableRow>
                  {headers.map((header, idx) => (
                    <TableHeader key={idx}>{header.header}</TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, idx) => (
                  <TableRow key={idx}>
                    {row.cells.map((cell, i) => (
                      <TableCell key={cell.id || i}>{cell.value}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </CarbonTable>
          )}
        </DataTable>
      ) : (
        <div className='inline-loader-wrapper'>
          <InlineLoading className='inline-loader' />
        </div>
      )}
    </div>
  )
}
